var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeleteModalIcon = function SvgDeleteModalIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4525E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3D49",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.15.1.1-Setup-/-Location---delete-location",
    transform: "translate(-672.597015, -309.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/07.Card/03.Popup/No-subtext",
    transform: "translate(520.000000, 269.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(152.597015, 40.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 48,
    cy: 48,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E2F2FF",
    opacity: 0.200000003,
    cx: 48,
    cy: 48,
    r: 39.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(28.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6041667,5.41666659 C24.0424082,5.41666659 25.2083334,6.58259173 25.2083334,8.02083327 L25.2083334,9.58333328 L31.4583334,9.58333328 C32.03363,9.58333328 32.4999999,10.0497033 32.4999999,10.625 C32.4999999,11.2002966 32.03363,11.6666666 31.4583334,11.6666666 L30.3515626,11.6666666 L29.1145834,31.5234376 C29.0039063,33.295573 27.6907552,34.5833334 25.9895834,34.5833334 L14.0104166,34.5833334 C12.3177083,34.5833334 10.9778645,33.2662761 10.8854166,31.5182292 L9.64843745,11.6666666 L8.54166661,11.6666666 C7.96636999,11.6666666 7.49999994,11.2002966 7.49999994,10.625 C7.49999994,10.0497033 7.96636999,9.58333328 8.54166661,9.58333328 L14.7916666,9.58333328 L14.7916666,8.02083327 C14.7916666,6.58259173 15.9575918,5.41666659 17.3958333,5.41666659 Z M15.2753906,13.75 C14.700094,13.7704949 14.2503384,14.2534794 14.2708333,14.828776 L14.7916666,29.4121094 C14.8116561,29.972864 15.2722226,30.4170229 15.8333333,30.4166669 L15.8704427,30.4166669 C16.1467698,30.4069981 16.407916,30.2878652 16.5963437,30.0855161 C16.7847714,29.8831669 16.8850193,29.6142053 16.875,29.3378907 L16.3541666,14.7545573 C16.3336717,14.1792606 15.8506872,13.729505 15.2753906,13.75 Z M20,13.75 C19.4247034,13.75 18.9583333,14.21637 18.9583333,14.7916666 L18.9583333,29.375 C18.9583333,29.9502967 19.4247034,30.4166667 20,30.4166667 C20.5752966,30.4166667 21.0416667,29.9502967 21.0416667,29.375 L21.0416667,14.7916666 C21.0416667,14.21637 20.5752966,13.75 20,13.75 Z M25.240471,13.9081115 C24.9248072,13.710554 24.5277261,13.696408 24.1988043,13.8710021 C23.8698826,14.0455963 23.6590912,14.3824056 23.6458334,14.7545573 L23.125,29.3378907 C23.1149786,29.6140964 23.2151378,29.8829621 23.403426,30.0852925 C23.5917142,30.2876229 23.8526939,30.4068294 24.1289063,30.4166669 L24.1666667,30.4166669 C24.7277774,30.4170229 25.1883439,29.972864 25.2083334,29.4121094 L25.7291667,14.828776 C25.7424246,14.4566244 25.5561349,14.105669 25.240471,13.9081115 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    mask: "url(#mask-3)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteModalIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-modal-icon.3ae4345e.svg";
export { ForwardRef as ReactComponent };